import { Controller } from "@hotwired/stimulus"
import "./component.scss"

// Minimal Stimulus controller - just imports SCSS for component styles
// Modal functionality is handled by the global dialog controller via Turbo Frames
export default class extends Controller {
}
